import type React from 'react';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

import { LearnMoreModal } from '../LearnMoreModal';

/**
 * The journalist ask's subhead, with the "Learn more" explainer trailing the sentence.
 *
 * The explainer sits inside the sentence, so it cannot be composed separately without drifting out
 * of place.
 *
 * Carries no typography of its own: whatever renders it owns the surrounding text style.
 */
export const JournalistOptInSubhead: React.FC<JournalistOptInSubheadProps> = ({ onLearnMoreClick }) => (
	<>
		<TranslateHtml value="corgi.petition.starter_onboarding.phone_collection_step_journalist.description" />{' '}
		<LearnMoreModal
			onTriggerClick={onLearnMoreClick}
			triggerLabel={<TranslateHtml value="corgi.petition.starter_onboarding.phone_collection_step_journalist.learn" />}
		/>
	</>
);

type JournalistOptInSubheadProps = Readonly<{
	onLearnMoreClick: () => void;
}>;
